export default __webpack_public_path__ + "static/media/empty-state-airport.bfcf3c6b.svg";